import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import {
  getActiveSubscriptions,
  getAvailableSubscriptions,
} from '../../api/subscriptions';
import SubscriptionBox from './subscriptionBox';

const Subscriptions = ({ login, redirectToOrder, subscribeAndOrder }) => {
  const [actSubscriptions, setSubscriptions] = useState([]);

  useEffect(() => {
    const fetchSubscriptions =
      login || subscribeAndOrder
        ? getAvailableSubscriptions
        : getActiveSubscriptions;

    fetchSubscriptions()
      .then((data) => {
        setSubscriptions(data);
      })
      .catch((error) => console.error(error));
  }, [login]);

  return (
    <Box sx={{ textAlign: 'center', mt: 4 }}>
      <Typography variant='h3' gutterBottom>
        Csomagjaink
      </Typography>

      <Box
        sx={{
          display: 'grid',

          justifyContent: 'center',
          gap: 2,
          mt: 2,
          gridTemplateColumns: {
            xs: '1fr',
            sm: '1fr ',
            md: '1fr 1fr',
            lg: '1fr 1fr 1fr',
          },
        }}
      >
        {actSubscriptions.map((v) => (
          <SubscriptionBox
            key={v.subscription_price_id}
            item={v}
            redirectToOrder={redirectToOrder}
            login={login}
            subscribeAndOrder={subscribeAndOrder}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Subscriptions;
